import React from "react";
import { Link } from 'react-scroll';

class Footer extends React.Component {
    render() {
        return (
            <React.Fragment>
                <footer className="footer-1 ptb-60">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-lg-4 mb-4 mb-md-4 mb-sm-4 mb-lg-0">
                                <a href="https://www.anthemav.com/">
                                    <img src="img/anthem_horizontal_logo_white_red.png" width="261px" alt="logo" className="img-fluid" />
                                </a>
                                <br />
                            </div>
                            <div className="col-md-12 col-lg-8">
                                <div className="row mt-0 justify-content-lg-end">
                                    <div className="col-sm-6 col-md-3 col-lg-3 mb-4 mb-sm-4 mb-md-0 mb-lg-0">
                                        <ul>
                                            <li>
                                                <a href="https://www.anthemav.com/products-current/">Products</a>
                                            </li>
                                            <li>
                                                <a href="https://www.anthemav.com/locator/index.php">Where to Buy</a>
                                            </li>
                                            <li>
                                                <a href="https://www.anthemav.com/support/social.php">Social</a>
                                            </li>
                                            <li>
                                                <a href="https://www.anthemav.com/support/index.php">Support</a>
                                            </li>
                                            <li>
                                                <a href="https://www.anthemav.com/videos/index.php">Videos</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-sm-6 col-md-3 col-lg-3 mb-4 mb-sm-4 mb-md-0 mb-lg-0">
                                        <ul>
                                            <li>
                                                <a href="https://www.anthemav.com/products-current/">Help</a>
                                            </li>
                                            <li>
                                                <a href="https://www.anthemav.com/support/contact-us.php">Contact Us</a>
                                            </li>
                                            <li>
                                                <a href="https://www.anthemav.com/support/manuals-literature.php">Product Support</a>
                                            </li>
                                            <li>
                                                <a href="https://dealers.paradigm.com/my-account/login/?redir=%2f">Dealer Resources</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-sm-6 col-md-3 col-lg-3 mb-4 mb-sm-4 mb-md-0 mb-lg-0">
                                        <ul>
                                            <li>
                                                <a href="https://www.anthemav.com/support/privacy.php">Privacy</a>
                                            </li>
                                            <li>
                                                <a href="/#">Terms</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
                <div className="footer-bottom py-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 col-lg-7">
                                <div className="copyright-wrap small-text">
                                    <p className="mb-0">&copy; 2022 Anthem. All rights reserved.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-5">
                                <div className="terms-policy-wrap text-lg-right text-md-right text-left">
                                    <ul className="list-inline">
                                        <li className="list-inline-item"><a className="img-fluid" href="https://www.facebook.com/anthemav"><img src="img/facebook.svg" alt="facebook icon"></img></a></li>
                                        <li className="list-inline-item"><a className="img-fluid" href="https://www.instagram.com/anthem_av/?hl=en"><img src="img/instagram.svg" alt="instagram icon"></img></a></li>
                                        <li className="list-inline-item"><a className="img-fluid" href="https://twitter.com/anthemav"><img src="img/twitter.svg" alt="twitter icon"></img></a></li>
                                        <li className="list-inline-item"><a className="img-fluid" href="https://www.flickr.com/photos/anthemav/sets/"><img src="img/flickr.svg" alt="flickr icon"></img></a></li>
                                        <li className="list-inline-item"><a className="img-fluid" href="https://www.youtube.com/user/AnthemAVTV"><img src="img/youtube.svg" alt="youtube icon"></img></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Footer;